import { FC } from 'react';
import { Box } from '@wix/design-system';

export interface GalleryHeaderContainerProps {
  className: string;
  children: React.ReactNode;
}

const GalleryHeaderContainer: FC<GalleryHeaderContainerProps> = ({
  className,
  children,
}) => {
  return <Box className={className}>{children}</Box>;
};

export default GalleryHeaderContainer;
